module.exports = {"first_name":"First name","enter_first_name":"Enter first name"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/i18next/en/firstName.json
// module id = 522
// module chunks = 245 976